interface ProgressBarProps {
  stepIndex: number;
  totalSteps: number;
  stepLabel: string;
}

export function ProgressBar({ stepIndex, totalSteps, stepLabel }: ProgressBarProps) {
  const current = stepIndex + 1;
  const percent = Math.round((current / totalSteps) * 100);

  return (
    <div className="progress" role="group" aria-label="Estimator progress">
      <div
        className="progress__track"
        role="progressbar"
        aria-label="Estimator progress"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        aria-valuetext={`Step ${current} of ${totalSteps}: ${stepLabel}`}
      >
        <div className="progress__fill" style={{ width: `${percent}%` }} />
      </div>
      <p className="progress__label">
        Step {current} of {totalSteps}
      </p>
    </div>
  );
}
